<!-- ========================================================== -->
<!-- DESKTOP -->
<!-- ========================================================== -->
<div id="summary" class="hidden md:block bg-main py-4 rounded-2.5xl text-white">
  @if (isTicketFeeEnabled && totalSeatsPriceWithFees) {
    <div
      class="flex justify-between items-center gap-2 bg-white bg-opacity-5 mx-2 mb-2 rounded-3xl font-thin text-white text-xs">
      <div class="flex justify-evenly items-center gap-1 ml-2 py-2">
        <span class="mr-1">Tickets Prices</span>
        <span class="mr-1 font-bold">
          ${{ totalSeatsPrice | number: '1.2-2' }}</span
        >
        <span>+</span>
        <span class="mr-1">Fees</span>
        <span class="font-bold"> ${{ totalSeatsFee | number: '1.2-2' }}</span>
      </div>
      <div
        class="flex justify-center items-center bg-white bg-opacity-10 p-2 rounded-3xl">
        <span class="mr-1">Total Balance:</span>
        <span class="font-bold" #total>
          ${{ totalSeatsPriceWithFees | number: '1.2-2' }}</span
        >
      </div>
    </div>
  }
  <div class="flex justify-between items-center gap-x-3 mx-2">
    <div class="flex justify-center items-center ml-2">
      <div class="flex items-center gap-2 mr-2">
        <p
          class="flex items-center font-normal"
          [ngClass]="{
            'w-30': isTicketFeeEnabled,
            'w-10': !isTicketFeeEnabled,
          }">
          Total Seats
        </p>
        <span class="flex items-center gap-1 w-5"
          ><img
            src="/assets/img/chair-white-icon.svg"
            alt="white chair icon"
            class="w-3" />:</span
        >
      </div>
      <div
        class="flex justify-center items-center px-2 border rounded-full w-14 h-8">
        <h5 data-cy="total-seats-count">{{ seats.length }}</h5>
      </div>
      @if (!isTicketFeeEnabled || !totalSeatsPriceWithFees) {
        <div class="ml-4 text-center">
          <p class="font-normal text-sm 3xl:text-base whitespace-nowrap">
            Ticket Total:
          </p>
          <p class="font-semibold text-base" #total>
            $ {{ totalSeatsPrice | number: '1.2-2' }}
          </p>
        </div>
      }
    </div>
    <div>
      @if (event) {
        <button
          class="disabled:opacity-30 w-40 font-bold disabled:hover:transform-none hover:scale-95 transition-transform btn-white"
          (click)="startCheckout()"
          [tooltip]="checkoutTooltipMessage"
          [adaptivePosition]="true"
          placement="top"
          container="body"
          [disabled]="!canCheckout">
          Go to Checkout
        </button>
      }
    </div>
  </div>
</div>

<!-- ========================================================== -->
<!-- MOBILE -->
<!-- ========================================================== -->
<div id="summary" class="md:hidden block px-4 py-2">
  @if (isTicketFeeEnabled && totalSeatsPriceWithFees) {
    <div
      class="flex flex-col justify-between items-center gap-2 bg-main-blue mb-2 py-2 rounded-3xl font-thin text-white text-xs">
      <div class="ml-2 py-2">
        <span class="mr-1">Tickets Prices</span>
        <span class="mr-1 font-bold">
          ${{ totalSeatsPrice | number: '1.2-2' }}</span
        >
        +
        <span class="mr-1">Fees</span>
        <span class="font-bold"> ${{ totalSeatsFee | number: '1.2-2' }}</span>
      </div>
      <div class="bg-main-lightblue p-2 rounded-3xl">
        <span class="mr-1">Total Balance:</span>
        <span class="font-bold">
          ${{ totalSeatsPriceWithFees | number: '1.2-2' }}</span
        >
      </div>
    </div>
  }
  <div class="bg-main px-6 py-4 rounded-2.5xl text-white">
    <div class="flex justify-center items-center mb-4">
      <div class="flex items-center mr-4">
        <h5 class="flex items-center mr-3">
          Total Seats
          <span class="mx-1 w-3"
            ><img
              src="/assets/img/chair-white-icon.svg"
              alt="white chair icon"
              class="w-3" /></span
          >:
        </h5>
        <div
          class="flex justify-center items-center px-4 border rounded-full w-16 h-8">
          <h5>{{ seats.length }}</h5>
        </div>
        @if (!isTicketFeeEnabled || !totalSeatsPriceWithFees) {
          <div class="flex-col justify-center items-center ml-3 text-center">
            <h4 class="font-normal text-sm 3xl:text-base">Ticket Total:</h4>
            <h4>$ {{ totalSeatsPrice | number: '1.2-2' }}</h4>
          </div>
        }
      </div>
    </div>
    <div>
      <button
        class="disabled:opacity-20 mx-auto w-40 font-bold disabled:hover:transform-none hover:scale-95 transition-transform btn-white"
        (click)="startCheckout()"
        [disabled]="!canCheckout">
        Go to Checkout
      </button>
    </div>
  </div>
</div>
